import { Link } from "react-router-dom";
import { X } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="container-narrow py-28 min-h-[70vh]" data-testid="payment-cancel-page">
      <div className="card-luxe max-w-xl mx-auto text-center">
        <div className="w-16 h-16 rounded-full bg-[#D91668]/20 text-[#D91668] flex items-center justify-center mx-auto">
          <X className="w-8 h-8" />
        </div>
        <h1 className="font-serif text-4xl mt-5">Payment cancelled</h1>
        <p className="text-white/90 mt-3">No worries — your card was not charged.</p>
        <p className="text-white/80 text-sm mt-3">You can go back and try again, or switch to Zelle or Cash App at checkout.</p>
        <div className="mt-7 flex flex-wrap gap-3 justify-center">
          <Link to="/blueprint" className="btn-gold">Back to Store</Link>
          <Link to="/" className="btn-ghost-gold">Home</Link>
        </div>
      </div>
    </div>
  );
}
